<template>
  <d-card class="mb-1 card-style">
    <d-card-body>
      <d-form class="add-new-post" @submit.prevent="submit">
        <strong class="text-muted d-block mb-2">Type</strong>
        <d-button-group class="mb-3">
          <d-button
            type="button"
            @click.native="form.type = 'donation';form.donationType='one-time'"
            v-bind:class="
              form.type === 'donation' ? 'btn-primary' : 'btn-white'
            "
          >Donation</d-button>
          <d-button
            type="button"
            @click.native="form.type = 'no-donation';form.donationType=''"
            v-bind:class="form.type === 'no-donation' ? 'btn-primary' : 'btn-white'"
          >No donation</d-button>
        </d-button-group>

        <strong class="text-muted d-block mb-2">Donation type</strong>
        <d-button-group class="mb-3">
          <d-button
            type="button"
            @click.native="form.donationType = 'one-time';form.type='donation'"
            v-bind:class="form.donationType === 'one-time' ? 'btn-primary' : 'btn-white'"
            >Default to One-Time</d-button
          >
          <d-button
            type="button"
            @click.native="form.donationType = 'monthly';form.type='donation'"
            v-bind:class="form.donationType === 'monthly' ? 'btn-primary' : 'btn-white'"
          >Default to Monthly</d-button>
          <d-button
            type="button"
            @click.native="form.donationType = '';form.type='no-donation'"
            v-bind:class="form.donationType === '' ? 'btn-primary' : 'btn-white'"
          >None</d-button>
        </d-button-group>
        <strong class="text-muted d-block mb-2">Title</strong>
        <div class="form-group">
          <d-input placeholder="Donate now" v-model="form.title" />
          <d-form-invalid-feedback :force-show="validations.title">Button text is required</d-form-invalid-feedback>
        </div>
        <textarea
          class="form-control"
          v-model="form.description"
          rows="6"
          max-rows="8"
          name="description"
          :style="{ fontSize: '1rem' }"
        />
        <div class="row" style="margin-right: -0px;
    margin-left: 0px;">
          <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0 pl-0 pr-0">
            <d-button
              v-if="addButton && !addCtaLoading && !updateCtaLoading"
              size="sm"
              class="btn-accent ml-auto mt-2"
              type="submit"
            >
              <i class="material-icons">add</i> Add Action
            </d-button>
            <d-button
              v-if="!addButton && !addCtaLoading && !updateCtaLoading"
              size="sm"
              class="btn-accent ml-auto mt-2"
              type="submit"
            >
              <i class="material-icons">save</i> Save
            </d-button>
            <d-button
              @click.native="cancel"
              v-if="!addButton && !addCtaLoading && !updateCtaLoading"
              size="sm"
              class="btn-accent cancel-btn ml-auto mt-2"
              type="button"
            >
              <i class="material-icons">cancel</i> Cancel
            </d-button>
            <d-button
              v-if="addCtaLoading || updateCtaLoading"
              size="sm"
              class="btn-accent loading-btn ml-auto mt-2"
              type="button"
            >
              <img
                class="loading-img"
                src="./../../assets/images/Spinner-1s-200px.svg"
                alt="Loader"
              />
            </d-button>
          </d-col>
        </div>
      </d-form>
    </d-card-body>
  </d-card>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  props: {
    selectedAction: {
      type: Object,
      default: function() {
        return {};
      }
    },
    addButton: { type: Boolean, default: true }
  },
  data() {
    return {
      text: "",
      showError: false,
      tier: {},
      toSubmit: {},
      form: {
        type: "donation",
        title: "",
        donation_details: { amount: 0, monthly: false, currency: "cad" },
        description: "",
        donationType: "one-time"
      },
      validations: {
        title: false,
        description: false
      }
    };
  },

  watch: {
    selectedAction(newSelectedAction) {
      
      this.form._id = newSelectedAction._id;
      this.form.type = newSelectedAction.type;
      this.form.title = newSelectedAction.title;
      this.form.description = newSelectedAction.description;
      if (newSelectedAction === "no-donation") {
        this.form.donationType = "";
      } else {
        this.form.donationType = newSelectedAction.donationType;
      }
    }
  },
  computed: {
    ...mapState({ 
      actions: state => state.actions.data.actions || [],
      type: state => state.actions.type,
       }),
    ...mapGetters(["addCtaLoading", "fetchCtasLoading", "updateCtaLoading"])
  },
  methods: {
    addButtonClicked(addButton, data) {
      this.$emit("addButtonClick", addButton, data);
    },
    formIsValid() {
      this.showError = false;
      this.toSubmit = {};
      if (this.form.description && this.form.title) {
        this.toSubmit.description = this.form.description;
        this.toSubmit.title = this.form.title;
        this.toSubmit.type = this.form.type;
        this.toSubmit.donationType = this.form.donationType;
        if (!this.addButton) {
          this.toSubmit._id = this.form._id;
        }
        return true;
      }
      return false;
    },
    iconPreview() {
      var iconLink =
        "https://givemagic.s3.us-east-2.amazonaws.com/core-assets-live/icons/" +
        this.form.icon +
        ".png";
      return iconLink;
    },
    submit() {
      this.validations = {
        title: false,
        description: false
      };
      if (this.formIsValid()) {
        if (this.addButton) {
          // this.$store.dispatch("addAction", this.toSubmit);
          this.addButtonClicked(true, this.toSubmit);
          this.form = {
            type: "donation",
            title: "",
            donationType:"one-time",
            donation_details: { amount: 0, monthly: false, currency: "cad" }
          };
        } else {
          this.$store.dispatch("updateCTA", this.toSubmit);
          this.form = {
            type: "donation",
            title: "",
            donationType:"one-time",
            donation_details: { amount: 0, monthly: false, currency: "cad" }
          };
          this.addButtonClicked(true);
        }
      } else {
        if (!this.form.title) {
          this.validations.title = true;
        } else if (!this.form.description) {
          this.validations.description = true;
        }
      }
    },
    cancel() {
      this.form = {
        type: "donation",
        title: "",
        description: "",
        donationType: "one-time",
        donation_details: { amount: 0, monthly: false, currency: "cad" }
      };
      this.addButtonClicked(true);
    }
  }
};
</script>

<style lang="scss" scoped>
.button-group-donation {
  margin-left: 10px;
}
.cancel-btn {
  margin-left: 10px !important;
}
.loading-btn {
  position: relative;
  padding: 15px;
  width: 4rem;

  .loading-img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 30px;
  }
}
.add-new-post__editor {
  min-height: 300px;
}
.icon-selector {
  display: none;
}
</style>
